export const getInitialBreakpoint = (responsive = {}) => {
  const breakpoints = Object.keys(responsive).sort();

  if (!breakpoints.length) {
    return 0;
  } else if (breakpoints.length === 1) {
    return breakpoints[0];
  } else {
    let breakpoint = 0;
    const width = window.innerWidth;
    breakpoints.forEach((b, i) => {
      if (width > parseInt(b)) {
        breakpoint = parseInt(breakpoints[i]);
      }
    });
    return breakpoint;
  }
};